export default {
  wrapper: {
    position: 'relative',
  },
  controlsWrapper: {
    top: '10px',
    left: '15px',
    zIndex: '100',
    position: 'absolute',
  },
  loadingWrapper: {
    zIndex: '100',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'hsla(0, 0%, 0%, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}



// WEBPACK FOOTER //
// ./src/Components/DrawMap/styles.js